export default __webpack_public_path__ + "436c18a2c593bcbc7980287bb0be16a2.png";